import { Component } from '@angular/core';

/**
 * @export
 * @class LsqComingSoonBoxComponent
 */
@Component({
    selector: 'lsq-coming-soon-box',
    template: `
        <div class="coming-soon-box">
            Coming Soon
        </div>
    `,
    styleUrls: ['./lsq-coming-soon-box.component.scss']
})
export class LsqComingSoonBoxComponent {}
